import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, ConfirmEventType, MessageService} from 'primeng/api';
import {InvoiceModel} from '../@shared/models/invoice.model';
import {ActivatedRoute, Router} from '@angular/router';
import {FormGroup} from '@angular/forms';
import {Paginator} from 'primeng/paginator';
import {Platform} from '@angular/cdk/platform';
import {CommonService} from '../@shared/services/common.service';
import {CacheService} from '../@shared/services/cache.service';
import {DatePipe} from '@angular/common';
import * as FileSaver from 'file-saver';
import {InvoiceAndSoaService} from '../@shared/new-services/invoice-and-soa.service';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit, OnDestroy {

    @ViewChild('pagination') pagination: Paginator;

    isLoading = false;
    invoices: any;
    filteredInvoices: any;
    displayInvoiceNumber: any;
    fromDate: any;
    toDate: any;
    selectedInvoiceNumber: any = this.cacheService.retrieveParsedResponse('selected-invoice-number');
    clearFilter = false;
    displayBookingNumber: any;
    displayCustRefNo: any;
    displaySelectedJobType: any;
    selectedBookingIdForInvoices: any;
    invoiceFilterObj: any;
    selectedView: any = 0;
    isFileDownloading: boolean;

    constructor(public commonService: CommonService,
                private messageService: MessageService,
                private router: Router,
                private cacheService: CacheService,
                private activatedRoute: ActivatedRoute,
                public platform: Platform,
                private confirmationService: ConfirmationService,
                private invoiceAndSoaService: InvoiceAndSoaService) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.selectedBookingIdForInvoices = params?.bookingId;
        });
        if (!this.selectedBookingIdForInvoices) {
            this.getFilteredInvoices();
            return;
        }
        this.getInvoicesFromBookingId(this.selectedBookingIdForInvoices);
        this.displayInvoiceNumber = 'For Booking ID - ' + this.selectedBookingIdForInvoices;
        this.clearFilter = true;
    }

    ngOnDestroy() {
        localStorage?.removeItem('selected-bookingId');
    }

    getFilteredInvoices(page = 0, size = 10, filterObject?: any) {
        this.isLoading = true;
        this.invoiceAndSoaService
            .getFilteredInvoices(filterObject, page, size)
            .subscribe(
                (x: any) => {
                    x.showMultipleBookings = false;
                    this.isLoading = false;
                    this.invoices = x;
                    this.filteredInvoices = x;

                }, (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        summary: 'Invoices !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'invoice-message'
                    });
                }
            );
    }

    paginateFilteredInvoices(paginateData: any) {
        if (!this.selectedBookingIdForInvoices) {
            this.getFilteredInvoices(paginateData?.page, 10, this.invoiceFilterObj);
            return;
        }
        this.getInvoicesFromBookingId(this.selectedBookingIdForInvoices[0], paginateData?.page);
    }

    getInvoicesFromBookingId(bookingId: string, page = 0, size = 10) {
        this.isLoading = true;
        this.invoiceAndSoaService.getInvoicesByBookingId(bookingId, page, size)
            .subscribe((res) => {
                this.isLoading = false;
                // if (res?.length >= 0) {
                this.invoices = res;
                this.filteredInvoices = res;
            }, (error) => {
                this.isLoading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Booking Invoices',
                    detail: error?.message ? error?.message : error,
                    key: 'invoice-message'
                });
            });
    }

    navigateToDocuments(invoice: any) {
        this.selectedInvoiceNumber = invoice.invoiceNumber;
        this.router.navigate(['/', 'documents-listing'],
            {
                queryParams: {
                    documentType: 'Invoice',
                    documentNumber: invoice?.invoiceNumber,
                    documentTypeGid: invoice?.invoiceGid,
                    bookingId: invoice?.bookingId
                }
            }
        );
    }

    applyFilterToInvoices(data: any) {
        if (data?.action === 'reset') {
            this.clearAllFilter();
            return;
        }
        this.invoiceFilterObj = data?.invoiceFilterValue;
        this.displayInvoiceNumber = this.invoiceFilterObj?.filterByIdentifier;
        this.fromDate = this.invoiceFilterObj?.fromDate;
        this.toDate = this.invoiceFilterObj?.toDate;
        this.displayBookingNumber = this.invoiceFilterObj?.bookingId;
        this.displayCustRefNo = this.invoiceFilterObj?.customerReferenceNumber;
        this.displaySelectedJobType = this.invoiceFilterObj?.orderTypes?.map((x) => {
            return x + ' ';
        });
        this.clearFilter = true;
        this.getFilteredInvoices(0, 10, this.invoiceFilterObj);
    }


    clearAllFilter() {
        this.displayInvoiceNumber = null;
        this.fromDate = null;
        this.toDate = null;
        this.displayBookingNumber = null;
        this.displayCustRefNo = null;
        this.displaySelectedJobType = null;
        this.clearFilter = false;
        this.getFilteredInvoices();
        this.pagination?.changePage(0);
        localStorage.removeItem('selected-bookingId');
        this.invoiceFilterObj = {};
        this.selectedBookingIdForInvoices = null;
    }

    getColourStatus(shipmentInvoiceType: any) {
        switch (shipmentInvoiceType) {
            case 'AIR':
                return 'shipment-type-air';
            case 'LCL':
                return 'shipment-type-lcl';
            case 'FCL':
                return 'p-text-success';
            case 'Transport':
                return 'p-text-warning';
            case 'Service Job':
                return 'shipment-type-sj';
            case 'Custom Clearance':
                return 'shipment-type-cc';
        }
    }

    handleCardViewActions(data: any) {
        if (data.actionFrom === 'view-document') {
            this.navigateToDocuments(data.invoice);
        }
    }

    featureNotAvailable() {
        this.messageService.add({
            summary: 'Feature Message !',
            severity: 'info',
            detail: 'Feature will be available soon',
            key: 'invoice-message',
        });
    }

    downloadFiles(fileType: string) {
        this.confirmationService.confirm({
            message: 'Select the option to download file.',
            header: 'Download Options',
            icon: 'pi pi-download',
            accept: () => {
                // Download the current page only.
                if (fileType === 'pdf') {
                    this.exportPdf(this.filteredInvoices?.content);
                } else if (fileType === 'excel') {
                    this.exportExcel(this.filteredInvoices?.content);
                }
            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // Download All Pages
                        this.isFileDownloading = true;
                        this.commonService?.getFilteredInvoices(null, 0, 10000)
                            .subscribe((x) => {
                                this.isFileDownloading = false;
                                if (fileType === 'pdf') {
                                    this.exportPdf(x?.content);
                                } else if (fileType === 'excel') {
                                    this.exportExcel(x?.content);
                                }
                            });
                        break;
                    case ConfirmEventType.CANCEL:
                        // Closed dialog box without any options to download.
                        break;
                }
            }
        });
    }

    exportExcel(dataContent: any) {
        const exportedBookings = this.exportedColumnsForFileDownload(dataContent);
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportedBookings);
            const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
            const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            this.saveAsExcelFile(excelBuffer, 'invoices');
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    exportPdf(dataContent: any) {
        const cols = [
            {field: 'shipmentType', header: 'Type'},
            {field: 'invoiceNumber', header: 'Invoice Number'},
            {field: 'invoiceDate', header: 'Invoice Date'},
            {field: 'bookingId', header: 'Booking Number'},
            {field: 'customerReferenceNumber', header: 'Customer Reference Number'},
            {field: 'transportDocuments', header: 'Transport Document'},
            {field: 'billTo', header: 'Bill To'},
            {field: 'formattedInvoiceAmount', header: 'Invoice Amount'}
        ];
        const exportedColumns = cols.map(col => (
            {title: col.header, dataKey: col.field}
        ));

        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(x => {
                // @ts-ignore
                // const doc = new jsPDF.default('l', '', '', '');
                const doc = new jsPDF.default({
                    orientation: 'landscape',
                });
                doc.text('Invoices', 15, 10);
                // @ts-ignore
                doc.autoTable(exportedColumns, dataContent, {
                    theme: 'grid',

                    columnStyles: {
                        0: {
                            columnWidth: 15
                        },
                        1: {
                            columnWidth: 30
                        },
                        2: {
                            columnWidth: 30
                        },
                        3: {
                            columnWidth: 35
                        },
                        4: {
                            columnWidth: 45
                        },
                        5: {
                            columnWidth: 40
                        },
                        6: {
                            columnWidth: 50
                        },
                        7: {
                            columnWidth: 30
                        },
                    },
                    headerStyles: {
                        theme: 'grid',
                        fillColor: '#3f51b5',
                    },
                });
                doc.save('invoices.pdf');
            });
        });
    }

    exportedColumnsForFileDownload(dataContent: any) {
        const datePipe = new DatePipe('en-US');
        const exportedInvoices = dataContent?.map((invoice) => {
            const exportInvoice = {
                Type: invoice?.shipmentType ? invoice?.shipmentType : '-',
                'Invoice Number': invoice?.invoiceNumber ? invoice?.invoiceNumber : '-',
                'Invoice Date': invoice?.invoiceDate ? datePipe.transform(invoice?.invoiceDate, 'dd-MMM-yyyy') : '-',
                'Booking Number': invoice?.bookingId ? invoice?.bookingId : '-',
                'Customer Reference Number': invoice?.customerReferenceNumber ? invoice?.customerReferenceNumber : '-',
                'Transport Document': invoice?.transportDocuments ? invoice?.transportDocuments : '-',
                'Bill To': invoice?.billTo ? invoice?.billTo : '-',
                'Invoice Amount': invoice?.formattedInvoiceAmount ? invoice?.formattedInvoiceAmount : '-'
            };
            return exportInvoice;
        });
        return exportedInvoices;
    }

    mouseLeave() {
        alert('Left');
    }
}
